// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body,html{font-weight:400;font-size:.09722rem;font-style:normal;font-variant:normal;font-display:swap}", ""]);
// Exports
module.exports = exports;
